import {Component, OnInit, OnDestroy, ViewChild} from '@angular/core';
import {NotifierService} from 'angular-notifier';
import {RestApiService} from '../rest-api.service';
import {MessageService} from '../message.service';
import {Router} from '@angular/router';
import {NgbModal, NgbModalRef} from '@ng-bootstrap/ng-bootstrap';
import {Formatters, OnEventArgs} from 'angular-slickgrid';
import {CustomInputEditor} from '../custom-inputEditor';
import {Subscription} from 'rxjs';
import {FormControl} from '@angular/forms';
import {J} from '@angular/cdk/keycodes';


@Component({
    selector: 'app-support-grp-sla-client',
    templateUrl: './support-grp-sla-client.component.html',
    styleUrls: ['./support-grp-sla-client.component.css']
})
export class SupportGrpSlaClientComponent implements OnInit, OnDestroy {

    vendorSelected: number;
    ticketSelected: number;
    groupSelected: number;
    prioritySelected: number;
    show: boolean;
    dataset: any[];
    totalData: number;
    respObject: any;
    vendors = [];
    tickets = [];
    groups = [];
    priorities = [];
    groupName: string;
    vendorName: string;
    ticketName: string;
    resoTime: string;
    respTime: string;
    name: string;
    desc: string;

    displayData: any;

    add = false;
    del = false;
    edit = false;
    view = false;

    isError = false;
    errorMessage: string;
    nextOffset: number;
    previousOffset: number;
    collectionSize: number;
    pageSize: number;
    paginationType: string;
    page_no: number;
    totalPage: number;
    offset: number;
    dataLoaded: boolean;
    isSupp: boolean;
    supportGroup = new FormControl();
    sgroupSelected = [];
    support_group = [];
    groupSelectedstr: string;
    options: any;
    optionName: string;
    priorityId: number;
    values: any;
    showSearch = true;
    isLoading = false;
    searchData: FormControl = new FormControl();
    slaSelected: any;
    sla: any;
    userName: string;
    resoT: any;
    respT: any;
    dataArr: any;
    selectedId: any;
    typeName: any;
    private notifier: NotifierService;
    private clientId: number;
    private priorityName: any;
    private userAuth: Subscription;
    private baseFlag: any;
    @ViewChild('scarch_content') private scarch_content;
    private searchModalReference: NgbModalRef;
    @ViewChild('content1') private content1;
    private modalReference: NgbModalRef;

    constructor(private _rest: RestApiService, private messageService: MessageService, private route: Router,
                private modalService: NgbModal, notifier: NotifierService) {

        this.notifier = notifier;
        this.messageService.getCellChangeData().subscribe(item => {
            switch (item.type) {
                case 'change':
                    // console.log('changed');
                    if (!this.messageService.edit) {
                        this.notifier.notify('error', 'You do not have edit permission');
                    } else {
                        if (confirm('Are you sure?')) {
                            // item.user_id = this.messageService.getUserId();
                            // if (item.resolutionTime > item.responseTime) {
                            //     this._rest.updateSLAClientWiseDetails(item).subscribe((res) => {
                            //         this.respObject = res;
                            //         if (this.respObject.success) {
                            //             this.notifier.notify('success', 'Updated successfully');
                            //         } else {
                            //             this.notifier.notify('error', this.respObject.errorMessage);
                            //         }
                            //     }, (err) => {
                            //         this.notifier.notify('error', this.messageService.SERVER_ERROR);
                            //     });
                            // } else {
                            //     this.notifier.notify('error', this.messageService.RESOLUTION_TIME_ERROR);
                            // }
                        }
                    }
                    break;
                case 'delete':
                    // console.log('deleted');
                    if (!this.messageService.del) {
                        this.notifier.notify('error', 'You do not have delete permission');
                    } else {
                        if (confirm('Are you sure?')) {
                            this._rest.deleteSLAClientWiseDetails({
                                id: item.id,
                                user_id: this.messageService.getUserId()
                            }).subscribe((res) => {
                                this.respObject = res;
                                if (this.respObject.success) {
                                    // this.totalData = this.totalData - 1;
                                    // this.messageService.setTotalData(this.totalData);
                                    this.messageService.sendAfterDelete(item.id);
                                } else {
                                    this.notifier.notify('error', this.respObject.errorMessage);
                                }
                            }, (err) => {
                                this.notifier.notify('error', this.respObject.errorMessage);
                            });
                        }
                    }
                    break;
            }
        });
    }

    ngOnInit() {


        this.isSupp = true;
        this.groupSelectedstr = '';
        this.sgroupSelected = [];
        this.dataLoaded = false;
        this.nextOffset = 0;
        this.previousOffset = 0;
        this.pageSize = this.messageService.pageSize;
        this.page_no = 0;
        this.totalPage = 0;
        this.paginationType = 'next';

        this.displayData = {
            pageName: 'View SLA Client With Support Group Wise',
            openModalButton: 'Add SLA Client With Group',
            searchModalButton: 'Search',

            breadcrumb: 'slaClient',
            folderName: 'All SLA Client With Support Group Wise',
            tabName: 'SLA Client With Support Group Wise'
        };
        const columnDefinitions = [
            {
                id: 'delete',
                field: 'id',
                excludeFromHeaderMenu: true,
                formatter: Formatters.deleteIcon,
                minWidth: 30,
                maxWidth: 30,
            },
            {
                id: 'edit',
                field: 'id',
                excludeFromHeaderMenu: true,
                formatter: Formatters.editIcon,
                minWidth: 30,
                maxWidth: 30,
                onCellClick: (e: Event, args: OnEventArgs) => {
                    console.log(args.dataContext);
                    this._rest.getSupportGroupByClientId(this.clientId).subscribe((res1) => {
                        this.respObject = res1;
                        if (this.respObject.success) {
                            // this.respObject.details.unshift({id: 0, name: 'Select support group'});
                            this.support_group = this.respObject.details;
                            // let x = this.respObject.details;
                            // console.log(JSON.stringify(x));
                        } else {
                            this.isError = true;
                            this.errorMessage = this.respObject.errorMessage;
                        }
                    }, (err) => {
                        this.isError = true;
                        this.errorMessage = this.messageService.SERVER_ERROR;
                    });

                    // this._rest.getSubClient(this.clientId).subscribe((res) => {
                    //     this.respObject = res;
                    //     if (this.respObject.success) {
                    //         const sub_client = this.respObject.details[0].sub_client;
                    //         // console.log(JSON.stringify(k));
                    //         if (sub_client === 1) {
                    //             this.isSupp = false;
                    //             this._rest.getSupportGroupByClientId(this.clientId).subscribe((res1) => {
                    //                 this.respObject = res1;
                    //                 if (this.respObject.success) {
                    //                     // this.respObject.details.unshift({id: 0, name: 'Select support group'});
                    //                     this.support_group = this.respObject.details;
                    //                     // let x = this.respObject.details;
                    //                     // console.log(JSON.stringify(x));
                    //                 } else {
                    //                     this.isError = true;
                    //                     this.errorMessage = this.respObject.errorMessage;
                    //                 }
                    //             }, (err) => {
                    //                 this.isError = true;
                    //                 this.errorMessage = this.messageService.SERVER_ERROR;
                    //             });
                    //         }
                    //     } else {
                    //         this.isError = true;
                    //         this.errorMessage = this.respObject.errorMessage;
                    //     }
                    // }, (err) => {
                    //     this.isError = true;
                    //     this.errorMessage = this.messageService.SERVER_ERROR;
                    // });
                    this.typeName = args.dataContext.ticket;
                    this.priorityName = args.dataContext.priority;
                    this.selectedId = args.dataContext.id;
                    this.name = args.dataContext.name;
                    this.desc = args.dataContext.des;
                    this.respTime = args.dataContext.responseTime;
                    this.resoTime = args.dataContext.resolutionTime;
                    var str = args.dataContext.supportGroupLevelId;
                    var str1 = str.substring(1, str.length - 1);
                    var str2 = str1.split(',');
                    this.sgroupSelected = str2.map(function (x) {
                        return parseInt(x, 10);
                    });

                    // console.log("----"+str);
                    // console.log("---------"+str1);
                    // console.log(this.sgroupSelected);


                    this.modalReference = this.modalService.open(this.content1, {});
                    this.modalReference.result.then((result) => {
                    }, (reason) => {

                    });
                }
            },

            // {id: 'id', name: 'Id', field: 'id', sortable: true, maxWidth: 40, filterable: true},
            {
                id: 'name', name: 'Name', field: 'name', sortable: true, filterable: true
            },
            {
                id: 'Description', name: 'Description', field: 'des', sortable: true, filterable: true
            },

            {
                id: 'supportGrp', name: 'Support Group', field: 'supportGrp', minWidth: 400, sortable: true, filterable: true
            },
            // {
            //   id: 'vendor', name: 'Vendor  ', field: 'vendor', sortable: true, filterable: true
            // },
            // {
            //   id: 'group', name: 'Support Group', field: 'groupname', sortable: true, filterable: true
            // },
            {
                id: 'ticket', name: 'Ticket Type ', field: 'ticket', sortable: true, filterable: true
            },
            {
                id: 'priority', name: 'Priority', field: 'priority', sortable: true, filterable: true
            },
            {
                id: 'respTime', name: 'Response Time', field: 'responseTime', sortable: true, filterable: true
            },
            {
                id: 'resTime', name: 'Resolution Time', field: 'resolutionTime', sortable: true, filterable: true
            }
        ];
        // this.messageService.setGridWidth(1000);
        this.messageService.setColumnDefinitions(columnDefinitions);
        if (this.messageService.clientId) {
            this.clientId = this.messageService.clientId;
            this.baseFlag = this.messageService.baseFlag;
            this.onPageLoad();
        } else {
            this.userAuth = this.messageService.getClientUserAuth().subscribe(auth => {
                this.view = auth[0].viewFlag;
                this.add = auth[0].addFlag;
                this.edit = auth[0].editFlag;
                this.del = auth[0].deleteFlag;
                this.clientId = auth[0].clientId;
                this.baseFlag = auth[0].baseFlag;
                this.onPageLoad();
            });
        }
    }


    onPageLoad() {
        this._rest.getTicketType(this.clientId).subscribe((res1) => {
            this.respObject = res1;
            if (this.respObject.success) {
                this.isError = false;
                this.respObject.details.unshift({id: 0, name: 'Select Ticket Type'});
                this.tickets = this.respObject.details;
                this.ticketSelected = 0;
            } else {
                this.notifier.notify('error', this.respObject.errorMessage);
            }
        }, (err) => {
            this.notifier.notify('error', JSON.stringify(err));
        });
        this.getTableData();
    }

    changeRouting(path: string) {
        this.messageService.changeRouting(path);
    }

// onVendorChange(selectedIndex) {
//   this.vendorName = this.vendors[selectedIndex].name;
//   this._rest.getSupportGroupByVendor(this.clientId, this.vendorSelected).subscribe((res1) => {
//     this.respObject = res1;
//     if (this.respObject.success) {
//       this.isError = false;
//       this.respObject.details.unshift({id: 0, name: 'Select Support Group'});
//       this.groups = this.respObject.details;
//       this.groupSelected = 0;
//     } else {
//       this.isError = true;
//       this.errorMessage = this.respObject.errorMessage;
//     }
//   }, (err) => {
//     this.isError = true;
//     this.errorMessage = this.messageService.SERVER_ERROR;
//   });
// }

    openModal(content) {

        this.isSupp = true;
        this.groupSelectedstr = '';
        this.sgroupSelected = [];
        if (!this.messageService.add) {
            this.notifier.notify('error', 'You do not have add permission');
        } else {
            this.isError = false;
            // this.vendorSelected = 0;
            // this.ticketSelected = 0;
            this.prioritySelected = 0;
            this.ticketSelected = 0;
            this.desc = '';
            this.name = '';
            this.modalService.open(content, {size: 'sm'}).result.then((result) => {
            }, (reason) => {
            });
            this._rest.getSupportGroupByClientId(this.clientId).subscribe((res1) => {
                this.respObject = res1;
                if (this.respObject.success) {
                    // this.respObject.details.unshift({id: 0, name: 'Select support group'});
                    this.support_group = this.respObject.details;
                    // let x = this.respObject.details;
                    // console.log(JSON.stringify(x));
                } else {
                    this.isError = true;
                    this.errorMessage = this.respObject.errorMessage;
                }
            }, (err) => {
                this.isError = true;
                this.errorMessage = this.messageService.SERVER_ERROR;
            });


            //     this._rest.getSubClient(this.clientId).subscribe((res) => {
            //         this.respObject = res;
            //         if (this.respObject.success) {
            //             const sub_client = this.respObject.details[0].sub_client;
            //             // console.log(JSON.stringify(k));
            //             if (sub_client === 1) {
            //                 this.isSupp = false;
            //             }
            //         } else {
            //             this.isError = true;
            //             this.errorMessage = this.respObject.errorMessage;
            //         }
            //     }, (err) => {
            //         this.isError = true;
            //         this.errorMessage = this.messageService.SERVER_ERROR;
            //     });
        }
    }


    searchModal() {
        this.slaSelected = '';

        this.searchModalReference = this.modalService.open(this.scarch_content);
        this.searchModalReference.result.then((result) => {
        }, (reason) => {

        });

    }

    search() {
        const data1 = [];
        this._rest.searchAllSupportGroupSlaClient(this.slaSelected, this.clientId).subscribe((res1) => {
            this.respObject = res1;
            this.isLoading = false;
            if (this.respObject.success) {
                this.sla = this.respObject.details;
                this.page_no = 1;
                this.messageService.setTotalData(this.sla.length);
                this.messageService.setGridData(this.sla);
                this.searchModalReference.close();

            } else {
                this.notifier.notify('error', this.respObject.errorMessage);
            }
        }, (err) => {
            this.isLoading = false;
            this.notifier.notify('error', this.messageService.SERVER_ERROR);
        });
    }


    timeFormat(date) {
// console.log(date);
        if (date !== undefined) {
            const d = new Date(date);
            const hour = d.getHours();
            const min = d.getMinutes();
            let nHour, nMin;
            if (hour < 10) {
                nHour = '0' + hour;
            } else {
                nHour = hour;
            }
            if (min < 10) {
                nMin = '0' + min;
            } else {
                nMin = min;
            }
            return nHour + ':' + nMin;
        } else {
            return '';
        }
    }


    update() {
        this.groupSelectedstr = this.sgroupSelected.toString();
        this.groupSelectedstr = ',' + this.groupSelectedstr + ',';
        // console.log(this.groupSelectedstr);
        const data = {
            id: this.selectedId,
            name: this.name,
            des: this.desc,
            resolutionTime: this.resoTime,
            responseTime: this.respTime,
            user_id: this.messageService.getUserId()
        };
        // console.log('data===' + JSON.stringify(data));
        if (!this.messageService.isBlankField(data)) {
            // console.log('not blank')
            // if (this.isSupp === true) {
            if (this.sgroupSelected.length > 0) {
                data['supportGroupLevelId'] = this.groupSelectedstr;
            } else {
                data['supportGroupLevelId'] = '';
            }
            // }
            if (Number(this.resoTime) > Number(this.respTime)) {
                // console.log('data  ' + JSON.stringify(data));
                this._rest.updateSLAClientWiseDetails(data).subscribe((res) => {
                    this.respObject = res;
                    if (this.respObject.success) {
                        this.isError = false;
                        this.nextOffset = 0;
                        this.page_no = 0;
                        this.getTableData();
                    } else {
                        this.isError = true;
                        this.errorMessage = this.respObject.errorMessage;
                    }
                }, (err) => {
                    this.isError = true;
                    this.errorMessage = this.messageService.SERVER_ERROR;
                });
            } else {
                this.isError = true;
                this.errorMessage = this.messageService.RESOLUTION_TIME_ERROR;
            }
        } else {
            this.isError = true;
            this.errorMessage = this.messageService.BLANK_ERROR_MESSAGE;
        }
    }


    save() {
        this.groupSelectedstr = this.sgroupSelected.toString();
        // console.log(this.groupSelectedstr);
        const data = {
            enable_escalation: 1,
            clientId: this.clientId,
            TICKETTYPEID: this.ticketSelected,
            name: this.name,
            des: this.desc,
            resolutionTime: this.resoTime,
            responseTime: this.respTime,
            busi_priority_id: this.prioritySelected,
            createdBy: this.messageService.getUserId()
        };

// if (this.optionSelected !== 1) {

//     data['name'] = this.name;
//     data['des'] = this.desc;
//     data['busi_priority_id'] = this.prioritySelected;
//     data['resolutionTime'] = this.resoTime;
//     data['responseTime'] = this.respTime;
// }

        // if (this.isSupp === false) {
        //     data['supportGroupLevelId'] = this.groupSelectedstr;
        // }
// console.log('data===' + JSON.stringify(data));
        if (!this.messageService.isBlankField(data)) {
            // console.log('not blank')
            // if (this.isSupp === true) {
            data['supportGroupLevelId'] = this.groupSelectedstr;
            // }
            if (Number(this.resoTime) > Number(this.respTime)) {
                console.log('data  ' + JSON.stringify(data));
                this._rest.insertSLAClientWiseDetails(data).subscribe((res) => {

                    this.respObject = res;
                    if (this.respObject.success) {
                        this.isError = false;
                        this.nextOffset = 0;
                        this.page_no = 0;
                        this.getTableData();

                        this.vendorSelected = 0;
                        this.ticketSelected = 0;
                        this.prioritySelected = 0;
                        this.ticketSelected = 0;
                        this.desc = '';
                        this.name = '';
                        this.groupSelectedstr = '';
                        this.sgroupSelected = [];
                    } else {
                        this.isError = true;
                        this.errorMessage = this.respObject.errorMessage;
                    }
                }, (err) => {
                    this.isError = true;
                    this.errorMessage = this.messageService.SERVER_ERROR;
                });
            } else {
                this.isError = true;
                this.errorMessage = this.messageService.RESOLUTION_TIME_ERROR;
            }
        } else {
            // console.log("blank");
            this.isError = true;
            this.errorMessage = this.messageService.BLANK_ERROR_MESSAGE;
        }
    }

    getTableData() {
        if (!this.messageService.view) {
            this.notifier.notify('error', 'You do not have view permission');
        } else {
            this.getData({'offset': this.nextOffset, 'paginationType': ''});
        }
    }

    isEmpty(obj) {
        for (const key in obj) {
            if (obj.hasOwnProperty(key)) {
                return false;
            }
        }
        return true;
    }

    getData(paginationObj) {
        const offset = paginationObj.offset;
        const paginationType = paginationObj.paginationType;
        this.dataLoaded = false;
        this._rest.getSLAClientWiseDetailsBySupGrp(this.clientId, offset, this.pageSize, paginationType).subscribe((res) => {
            this.respObject = res;
            this.executeResponse(this.respObject, offset, paginationType);
        }, (err) => {
            this.notifier.notify('error', this.messageService.SERVER_ERROR);
        });
    }

    executeResponse(respObject, offset, paginationType) {
        if (respObject.success) {
            this.dataLoaded = true;
            if (offset === 0) {
                this.totalData = respObject.details.totalData[0].count;
                this.totalPage = respObject.details.totalPage;
                if (this.totalPage === 0) {
                    this.totalPage = 1;
                }
            }
            if (!this.isEmpty(respObject.details.dataObj)) {
                const data = respObject.details.dataObj;
                this.nextOffset = respObject.details.nextOffset;
                this.offset = respObject.details.nextOffset;
                this.previousOffset = respObject.details.previousOffset;
                this.messageService.setTotalData(this.totalData);
                this.messageService.setGridData(data);
                // ----------------------------------------------
                if (offset !== 0) {
                    const totalCount = this.totalData;
                    const divRes = totalCount / this.pageSize;
                    const remainder = totalCount % this.pageSize;
                    if (remainder === 0) {
                        this.totalPage = parseInt(String(divRes), 10);
                    } else {
                        this.totalPage = parseInt(String(divRes), 10) + 1;
                    }
                }
                // ------------------------------------------------
                if (paginationType === 'next') {
                    this.page_no = this.page_no + 1;
                } else if (paginationType === 'prev') {
                    this.page_no = this.page_no - 1;
                } else if (paginationType === '' && this.page_no === 0) {
                    this.page_no = this.page_no + 1;
                }
                if (this.totalData <= this.pageSize * this.page_no) {
                    this.nextOffset = 0;
                }
            } else if (this.isEmpty(respObject.details.dataObj) && paginationType === 'next') {
                this.nextOffset = 0;
            } else if (this.isEmpty(respObject.details.dataObj) && paginationType === 'prev') {
                this.previousOffset = 0;
            } else if (paginationType === '' && this.page_no === 0) {
                this.page_no = this.page_no + 1;
            }
        } else {
            this.notifier.notify('error', respObject.errorMessage);
        }
    }

    onPageSizeChange(value: any) {
        this.page_no = 0;
        this.nextOffset = 0;
        this.pageSize = value;
        this.getData({'offset': this.nextOffset, 'paginationType': ''});
    }

    onTicketChange(selectedIndex: any) {
        this.ticketName = this.tickets[selectedIndex].name;
        this._rest.getBusinessPriorityTicketTypeWise(this.clientId, this.ticketSelected).subscribe((res1) => {
            this.respObject = res1;
            if (this.respObject.success) {
                this.isError = false;
                this.respObject.details.unshift({id: 0, name: 'Select Priority'});
                this.priorities = this.respObject.details;
                this.prioritySelected = 0;
            } else {
                this.isError = true;
                this.errorMessage = this.respObject.errorMessage;
            }
        }, (err) => {
            this.isError = true;
            this.errorMessage = this.messageService.SERVER_ERROR;
        });
    }

// onGroupChange(selectedIndex: any) {
//   this.groupName = this.groups[selectedIndex].name;
// }

    onPriorityChange(selectedIndex: any) {
        this.priorityName = this.priorities[selectedIndex].name;
        this.priorityId = this.priorities[selectedIndex].id;
        console.log('priority' + this.priorityId);


        this._rest.getClientWiseSlaClient(this.clientId, this.ticketSelected, this.priorityId).subscribe((res1) => {
            this.respObject = res1;
            console.log('.................' + JSON.stringify(this.respObject));
            if (this.respObject.success) {
                this.isError = false;

                this.values = this.respObject.details;
                this.name = this.values[0].NAME;
                this.desc = this.values[0].DESCRIPTIONS;
                this.respTime = this.values[0].RESPONSETIME;
                this.resoTime = this.values[0].RESOLUTIONTIME;

                console.log('value' + JSON.stringify(this.values));
                console.log('name' + this.name);

            } else {
                this.isError = true;
                this.errorMessage = this.respObject.errorMessage;
            }
        }, (err) => {
            this.isError = true;
            this.errorMessage = this.messageService.SERVER_ERROR;
        });
    }

    ngOnDestroy(): void {
        if (this.userAuth) {
            this.userAuth.unsubscribe();
        }
    }


}
